import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  balances: [],
};
const getters = {
  balances: state => state.balances,
};
const mutations = {
  [TYPES.SET_BALANCES](state, payload) {
    state.balances = payload;
  },
};
const actions = {
  /**
   * 获取科目余额表
   * @param commit
   * @param ts
   * @param params
   */
  getBalances: ({commit}, {ts, params}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/balance" + ts, {params: {...params,sort:'createDate,desc'}})
      .then(response => {
        commit(TYPES.SET_BALANCES, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}